import { GetTradeJumpInfoApi } from "@/features/trade-jump/services/get-trade-jump-info-api";
import { GetTradeJumpInfoRequestModel } from "@/features/trade-jump/services/get-trade-jump-info-model";

/// 明細ジャンプ情報取得画面処理
export class GetTradeJumpInfoService {
  private getTradeJumpInfoApi = new GetTradeJumpInfoApi();

  /**
   * 明細ジャンプ情報取得API実行
   */
  public async getTradeJumpInfo(param: GetTradeJumpInfoRequestModel) {
    return await this.getTradeJumpInfoApi.getTradeJumpInfo(param);
  }
}
